"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Caption = _interopRequireDefault(require("./Caption"));

require("../styles/_captions.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function isTargetLang(_ref, language) {
  var metaData = _ref.metaData;

  try {
    var _JSON$parse = JSON.parse(metaData),
        lang = _JSON$parse.lang;

    return lang.toUpperCase() === language.toUpperCase();
  } catch (err) {
    return false;
  }
}

function getSRTCaptions(appliedCaptions, organisationId, assetId) {
  var existingSRTs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var existingVTTs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var apolloClient = arguments.length > 5 ? arguments[5] : undefined;
  var createFile = arguments.length > 6 ? arguments[6] : undefined;
  var updateFile = arguments.length > 7 ? arguments[7] : undefined;
  return appliedCaptions.map(function (_ref2) {
    var lang = _ref2.value;
    var currentSrt = existingSRTs.find(function (caption) {
      return isTargetLang(caption, lang);
    });
    var currentVtt = existingVTTs.find(function (caption) {
      return isTargetLang(caption, lang);
    });
    return (/*#__PURE__*/_react.default.createElement(_Caption.default, {
        defaultLanguage: {
          value: lang
        },
        key: lang,
        organisationId: organisationId,
        assetId: assetId,
        currentCaptions: {
          CAPTION: currentSrt,
          VTT_CAPTION: currentVtt
        },
        apolloClient: apolloClient,
        createFile: createFile,
        updateFile: updateFile
      })
    );
  });
}

function SRTCaptions(_ref3) {
  var appliedAddons = _ref3.appliedAddons,
      organisationId = _ref3.organisationId,
      assetId = _ref3.assetId,
      _ref3$existingSRTs = _ref3.existingSRTs,
      existingSRTs = _ref3$existingSRTs === void 0 ? [] : _ref3$existingSRTs,
      _ref3$existingVTTs = _ref3.existingVTTs,
      existingVTTs = _ref3$existingVTTs === void 0 ? [] : _ref3$existingVTTs,
      apolloClient = _ref3.apolloClient,
      createFile = _ref3.createFile,
      updateFile = _ref3.updateFile;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "captions"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "captions__content"
    }, appliedAddons.SRT_CAPTIONS && Array.isArray(appliedAddons.SRT_CAPTIONS) ? getSRTCaptions(appliedAddons.SRT_CAPTIONS, organisationId, assetId, existingSRTs, existingVTTs, apolloClient, createFile, updateFile) : null))
  );
}

var _default = (0, _react.memo)(SRTCaptions);

exports.default = _default;